/*
 *
 * App
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectAuthToken, selectIsPhotographer, selectUser } from './selectors';
import { signOut } from './actions';
import Wrapper from './Wrapper';

import RootModal from 'containers/RootModal';
import LeftMenu from 'components/LeftMenu';
import TopMenu from 'components/TopMenu';
import GetStartedMenu from 'components/GetStartedMenu';
import Intercom from 'components/Intercom';

class App extends React.PureComponent {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      return document.getElementById('main-app').scrollTop = 0;
    }
  }
  render() {
    const {
      handleSignOut,
      authToken,
      isPhotographer,
      user,
      ...rest
    } = this.props;

    return (
      <Wrapper id="main-app">
        <RootModal />
        { !!authToken ? <Intercom {...user} /> : null }
        { !!authToken
            ?
              <LeftMenu isPhotographer={isPhotographer} signOut={handleSignOut}>
                <TopMenu>
                  <rest.switchComponent authenticated={true}/>
                </TopMenu>
              </LeftMenu>
            :
              <GetStartedMenu>
                <rest.switchComponent authenticated={false}/>
              </GetStartedMenu>
        }
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => createStructuredSelector({
  user: selectUser(),
  authToken: selectAuthToken(),
  isPhotographer: selectIsPhotographer(),
});

const mapDispatchToProps = (dispatch) => ({
  handleSignOut: () => dispatch(signOut()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js